import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { AdminUserPassword } from 'components/DashBoardBlocks/LeftTabsBlock/TabsContent/AdminUserPassword';

const Password: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <AdminUserPassword />
    </Container>
  );
});

export default Password;
